import { Box } from "@mui/system";
import { Container } from "@mui/material";
import LoadingDots from "components/LoadingDots";
import main_white from "assets/static/logo/logo.png";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "./index.modules.css";
import { get } from "utilities/requests";
import { URL } from "utilities/variables";
import CustomSection from "components/CustomSection";

const TermosUsoPage = () => {
  const [readyToRender, setReadyToRender] = useState(false);
  const [all_terms, setAllTerms] = useState({});

  const getto = async () => {
    const res = await get(`policy-and-terms`);
    setReadyToRender(true);
    setAllTerms(res);
  };

  useEffect(() => {
    getto().catch((e) => {
      console.log(e);
    });
  }, []);

  return (
    <CustomSection
      style={{
        overflow: "hidden",
        position: "relative",
        minHeight: "auto",
      }}
    >
      {readyToRender ? (
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1.8rem",
            margin: "auto",
            padding: "8rem 0",
            width: "100vw",
            animation: "show_section 1s",
          }}
        >
          <img
            src={main_white}
            alt="OnTest logotipo"
            style={{
              width: "20rem",
              margin: "10rem auto 6rem auto",
            }}
          />

          <div
            style={{
              margin: "6rem 0",
              gap: "4rem",
              flexDirection: "column",
              lineHeight:2
            }}
          >
            <h1 style={{textAlign:'center'}}>TERMO DE USO</h1>

<p><b>1. Aceitação dos Termos</b></p>
<p>Ao acessar ou utilizar este software, o usuário declara ter lido, compreendido e aceitado integralmente as condições estabelecidas neste Termo de Uso. Caso não concorde com alguma das disposições, deverá descontinuar o uso imediatamente.</p>

<p><b>2. Definições</b></p>
<p>Para fins deste Termo:</p>

<p>“Usuário” é toda pessoa que acessa ou utiliza o software;</p>

<p>“Software” refere-se à aplicação, site, sistema ou serviço digital oferecido pela EnterScience;</p>

<p>“Empresa” é a detentora dos direitos de propriedade intelectual e responsável pela disponibilização do software.</p>

<p><b>3. Uso do Software</b></p>
<p>O usuário compromete-se a utilizar o software de forma ética, legal e em conformidade com este Termo. É proibido:</p>

<p>Realizar engenharia reversa, cópia ou modificação não autorizada do software;</p>

<p>Utilizar o software para fins ilícitos, fraudulentos ou que violem direitos de terceiros;</p>

<p>Acessar áreas restritas ou tentar comprometer a segurança do sistema.</p>

<p><b>4. Cadastro e Conta de Usuário</b></p>
<p>Caso o software exija cadastro, o usuário se compromete a fornecer informações verdadeiras e atualizadas.</p>
<p>O usuário é responsável por manter a confidencialidade de seu login e senha, bem como por todas as atividades realizadas sob sua conta.</p>

<p><b>5. Propriedade Intelectual</b></p>
<p>Todo o conteúdo, layout, código-fonte, marcas, logotipos e demais elementos do software são de propriedade exclusiva da EnterScience, sendo protegidos por leis nacionais e internacionais de propriedade intelectual.</p>
<p>A utilização não confere ao usuário qualquer direito de propriedade sobre tais elementos.</p>

<p><b>6. Limitação de Responsabilidade</b></p>
<p>O software é fornecido “no estado em que se encontra”, sem garantias expressas ou implícitas.</p>
<p>A EnterScience não se responsabiliza por:</p>

<p>Danos diretos ou indiretos decorrentes do uso ou da incapacidade de uso do software;</p>

<p>Falhas causadas por terceiros, como provedores de internet ou falhas de rede;</p>

<p>Perda de dados resultante de uso indevido ou falhas externas.</p>

<p><b>7. Privacidade e Proteção de Dados</b></p>
<p>O tratamento de dados pessoais é regido pela Política de Privacidade, disponível em https://www.ontest.com.br/politica-de-privacidade.</p>
<p>Ao utilizar o software, o usuário concorda com as práticas ali descritas.</p>

<p><b>8. Alterações dos Termos</b></p>
<p>A EnterScience poderá alterar este Termo a qualquer momento. As versões atualizadas serão disponibilizadas no software ou site, e o uso contínuo após a publicação implica concordância com as modificações.</p>

<p><b>9. Encerramento e Suspensão de Acesso</b></p>
<p>A EnterScience poderá suspender ou encerrar o acesso do usuário em caso de violação destes Termos, uso indevido ou determinação legal.</p>

<p><b>10. Disposições Gerais</b></p>
<p>Este Termo é regido pelas leis da República Federativa do Brasil.</p>
<p>Fica eleito o foro da comarca de São José do Rio Preto/SP para dirimir eventuais controvérsias, com renúncia a qualquer outro, por mais privilegiado que seja.</p>
            {/* {all_terms["terms"].map((term, index) => {
              const [title, text] = term.content.split("_{slice}_");
              return (
                <div key={index} className="text-row">
                  <h2>{title}</h2>
                  <Typography variant="p"
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                </div>
              );
            })} */}

            {/* caso não exista texto para mostrar, uma outra mensagem será mostrada: */}
            {/* {all_terms["terms"].length === 0 ? (
              <>
                <p
                  style={{
                    fontSize: "2rem",
                    color: "var(--purple)",
                    textAlign: "center",
                    margin: "6rem 0",
                    fontFamily: "var(--Raleway)",
                  }}
                >
                  Não há termos de uso.
                </p>
              </>
            ) : (
              ""
            )} */}
          </div>
        </Container>
      ) : (
        <div
          style={{
            backgroundColor: "rgb(240, 244, 247)",
            minWidth: "100vw",
            minHeight: "100vh",
          }}
        >
          <LoadingDots />
        </div>
      )}
    </CustomSection>
  );
};

export default TermosUsoPage;
